
{
  "familyId": "TIJD-SCHEMA",
  "questions": [
    {
      "id": "TIJD-SCHEMA-001",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "De bus vertrekt om 14:20 en komt aan om 14:55. Hoe lang duurt de rit?",
      "options": ["35 minuten", "25 minuten", "45 minuten", "1 uur en 35 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_duration_simple",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "timeline",
          "data": {
            "label": "Busrit",
            "events": [
              { "position": 14.333, "label": "14:20", "description": "Vertrek", "isHighlighted": true },
              { "position": 14.917, "label": "14:55", "description": "Aankomst", "isHighlighted": true }
            ],
            "start": 14.0,
            "end": 15.0
          },
          "a11y": { "alt": "Tijdlijn van 14:00 tot 15:00 met vertrek 14:20 en aankomst 14:55" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ritduur berekenen",
            "content": "Trek de vertrektijd af van de aankomsttijd. 14:55 − 14:20 = 35 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de vertrektijd af van de aankomsttijd. Omdat beide tijden in hetzelfde uur vallen, trek je alleen de minuten af: 55 − 20 = 35 minuten. De rit duurt 35 minuten.",
        "solutionSteps": [
          "Vertrektijd: 14:20, aankomsttijd: 14:55",
          "Beide tijden vallen in hetzelfde uur (14:xx)",
          "Trek de minuten af: 55 − 20 = 35 minuten",
          "Check: 14:20 + 35 min = 14:55 ✓"
        ],
        "distractorExplanations": {
          "0": "Correct! 14:55 − 14:20 = 35 minuten.",
          "1": "De minuten zijn verkeerd afgetrokken. 55 − 20 = 35 minuten, niet 25. Controleer: 14:20 + 25 = 14:45, niet 14:55.",
          "2": "De minuten zijn verkeerd afgetrokken. 55 − 20 = 35 minuten, niet 45. Controleer: 14:20 + 45 = 15:05, niet 14:55.",
          "3": "Hier is een extra uur meegeteld. Beide tijden zijn in hetzelfde uur (14:xx), dus de rit duurt minder dan 1 uur: 35 minuten."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-subtraction-error", "label": "Minuten verkeerd afgetrokken (te weinig)", "optionIndex": 1 },
          { "id": "tijd.minutes-subtraction-error", "label": "Minuten verkeerd afgetrokken (te veel)", "optionIndex": 2 },
          { "id": "tijd.extra-hour-added", "label": "Extra uur ten onrechte meegeteld", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-002",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "fill_in",
      "question": "De trein vertrekt om 09:15. Je moet 10 minuten voor vertrek op het perron zijn. Hoe laat moet je er zijn? Typ de tijd als hh:mm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["09:05", "9:05"],
        "caseSensitive": false,
        "placeholder": "hh:mm"
      },
      "conceptId": "schedule_arrive_early",
      "variantIndex": 2,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 9, "minutes": 15, "format": "24h", "label": "Vertrektijd trein" },
          "a11y": { "alt": "Digitale klok toont 09:15, de vertrektijd van de trein" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerder op het perron",
            "content": "Trek 10 minuten af van de vertrektijd: 09:15 − 10 minuten = 09:05.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Als je eerder moet zijn, trek je de tijd af van de vertrektijd. De vertrektijd is 09:15. Je moet 10 minuten eerder zijn: 09:15 − 10 = 09:05.",
        "solutionSteps": [
          "Vertrektijd: 09:15",
          "Je moet 10 minuten eerder zijn",
          "Trek af: 09:15 − 10 minuten = 09:05",
          "Check: 09:05 + 10 min = 09:15 ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.add-instead-of-subtract", "label": "Optellen i.p.v. aftrekken bij 'eerder'" }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-003",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Je komt aan op het station om 16:30. De volgende bus vertrekt om 16:50. Hoe lang moet je wachten?",
      "options": ["10 minuten", "30 minuten", "20 minuten", "1 uur en 20 minuten"],
      "correctAnswer": 2,
      "conceptId": "schedule_waiting_time",
      "variantIndex": 3,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "timeline",
          "data": {
            "label": "Wachttijd op het station",
            "events": [
              { "position": 16.5, "label": "16:30", "description": "Aankomst", "isHighlighted": true },
              { "position": 16.833, "label": "16:50", "description": "Bus vertrekt", "isHighlighted": true }
            ],
            "start": 16.0,
            "end": 17.0
          },
          "a11y": { "alt": "Tijdlijn met aankomst 16:30 en busvertrek 16:50" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wachttijd berekenen",
            "content": "Trek de aankomsttijd af van de bustijd: 16:50 − 16:30 = 20 minuten wachten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De wachttijd bereken je door de aankomsttijd af te trekken van de bustijd. Omdat beide tijden in hetzelfde uur vallen, trek je alleen de minuten af: 50 − 30 = 20 minuten wachten.",
        "solutionSteps": [
          "Aankomsttijd: 16:30, bustijd: 16:50",
          "Beide tijden vallen in hetzelfde uur (16:xx)",
          "Trek de minuten af: 50 − 30 = 20 minuten",
          "Check: 16:30 + 20 min = 16:50 ✓"
        ],
        "distractorExplanations": {
          "0": "De minuten zijn verkeerd afgetrokken. 50 − 30 = 20 minuten, niet 10. Controleer: 16:30 + 10 = 16:40 ≠ 16:50.",
          "1": "De minuten zijn verkeerd afgetrokken. 50 − 30 = 20 minuten, niet 30. Controleer: 16:30 + 30 = 17:00 ≠ 16:50.",
          "2": "Correct! 16:50 − 16:30 = 20 minuten.",
          "3": "Hier is een extra uur meegeteld. Beide tijden zijn in hetzelfde uur (16:xx), dus je wacht minder dan 1 uur: 20 minuten."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-subtraction-error", "label": "Minuten verkeerd afgetrokken (te weinig)", "optionIndex": 0 },
          { "id": "tijd.minutes-subtraction-error", "label": "Minuten verkeerd afgetrokken (te veel)", "optionIndex": 1 },
          { "id": "tijd.extra-hour-added", "label": "Extra uur ten onrechte meegeteld", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-004",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "true_false_series",
      "question": "Klopt elke bewering over deze tijdberekeningen?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Een les van 10:00 tot 10:50 duurt 50 minuten.", "isTrue": true, "explanation": "Beide tijden in uur 10. 50 − 0 = 50 minuten. Klopt." },
          { "text": "Van 13:45 tot 14:10 is 35 minuten.", "isTrue": false, "explanation": "Splits bij de uurgrens: 13:45 → 14:00 = 15 min, 14:00 → 14:10 = 10 min. Totaal 25 minuten, niet 35." },
          { "text": "Van 09:00 tot 10:45 is 1 uur en 45 minuten.", "isTrue": true, "explanation": "09:00 → 10:00 = 1 uur, 10:00 → 10:45 = 45 min. Totaal 1 uur en 45 minuten. Klopt." },
          { "text": "Als de bus om 08:50 vertrekt en je moet 20 min eerder zijn, moet je er om 08:40 zijn.", "isTrue": false, "explanation": "08:50 − 20 min = 08:30, niet 08:40. Er is maar 10 min afgetrokken." },
          { "text": "Een film die om 19:30 begint en 1 uur en 45 min duurt, is om 21:15 afgelopen.", "isTrue": true, "explanation": "19:30 + 1 uur = 20:30. 20:30 + 45 min = 21:15. Klopt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check elke bewering",
            "content": "Stap 1: bepaal of de tijden in hetzelfde uur vallen of over de uurgrens gaan. Stap 2: splits bij de uurgrens. Stap 3: tel of trek af. Stap 4: vergelijk met de bewering.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schedule_judge_series",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Voor elke bewering: bepaal of het in één uur valt of over de uurgrens gaat. Bij uurgrens: splits in twee stukken. Bij 'eerder' of 'later': tel op of trek af van de referentietijd.",
        "solutionSteps": [
          "Lees elke bewering rustig",
          "Identificeer: zelfde uur, uurgrens, of optellen/aftrekken?",
          "Reken stap voor stap",
          "Vergelijk je antwoord met de bewering"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.cross-hour-only-first-part", "label": "Bij uurgrens: alleen eerste deel of fout opgeteld" },
          { "id": "tijd.minutes-subtraction-error", "label": "Minuten te weinig afgetrokken" }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-005",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "step_solver",
      "question": "De metro vertrekt om 13:45 en komt aan om 14:10. Bereken stap voor stap hoe lang de rit duurt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          {
            "prompt": "Stap 1: Hoeveel minuten zijn er van 13:45 tot 14:00?",
            "correctAnswer": "15",
            "acceptedAnswers": ["15", "15 min", "15 minuten"],
            "placeholder": "... min"
          },
          {
            "prompt": "Stap 2: Hoeveel minuten zijn er van 14:00 tot 14:10?",
            "correctAnswer": "10",
            "acceptedAnswers": ["10", "10 min", "10 minuten"],
            "placeholder": "... min"
          },
          {
            "prompt": "Stap 3: Wat is de totale rittijd in minuten?",
            "correctAnswer": "25",
            "acceptedAnswers": ["25", "25 min", "25 minuten"],
            "placeholder": "... min"
          }
        ]
      },
      "conceptId": "schedule_duration_cross_hour",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "timeline",
          "data": {
            "label": "Metrorit over de uurgrens",
            "events": [
              { "position": 13.75, "label": "13:45", "description": "Vertrek", "isHighlighted": true },
              { "position": 14.0, "label": "14:00", "description": "Uurgrens", "isHighlighted": false },
              { "position": 14.167, "label": "14:10", "description": "Aankomst", "isHighlighted": true }
            ],
            "start": 13.5,
            "end": 14.5
          },
          "a11y": { "alt": "Tijdlijn van 13:30 tot 14:30 met vertrek 13:45, uurgrens 14:00, aankomst 14:10" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ritduur over uurgrens",
            "content": "Splits bij het hele uur. Eerste stuk: van vertrek tot heel uur. Tweede stuk: van heel uur tot aankomst. Tel beide stukken op.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Splits de berekening bij de uurgrens. Van 13:45 naar 14:00 is 15 minuten (60 − 45 = 15). Van 14:00 naar 14:10 is 10 minuten. Totaal: 15 + 10 = 25 minuten.",
        "solutionSteps": [
          "De rit gaat over de uurgrens (13 → 14)",
          "Eerste stuk: 13:45 → 14:00 = 15 minuten",
          "Tweede stuk: 14:00 → 14:10 = 10 minuten",
          "Totaal: 15 + 10 = 25 minuten"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.cross-hour-only-first-part", "label": "Alleen eerste deel meegeteld, tweede deel vergeten" }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-006",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Je moet om 15:30 bij de tandarts zijn. Je wilt 15 minuten voor de afspraak er zijn. Hoe laat moet je aankomen?",
      "options": ["15:20", "15:45", "14:15", "15:15"],
      "correctAnswer": 3,
      "conceptId": "schedule_arrive_before_appointment",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 15, "minutes": 30, "format": "24h", "label": "Afspraaktijd tandarts" },
          "a11y": { "alt": "Digitale klok toont 15:30, de afspraaktijd bij de tandarts" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerder aankomen",
            "content": "Trek 15 minuten af van de afspraaktijd: 15:30 − 15 minuten = 15:15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Als je eerder moet zijn, trek je de tijd af van de afspraaktijd. De afspraak is om 15:30. Je wilt 15 minuten eerder zijn: 15:30 − 15 = 15:15.",
        "solutionSteps": [
          "Afspraaktijd: 15:30",
          "Je wilt 15 minuten eerder zijn",
          "Trek af: 15:30 − 15 minuten = 15:15",
          "Check: 15:15 + 15 min = 15:30 ✓"
        ],
        "distractorExplanations": {
          "0": "Hier zijn maar 10 minuten afgetrokken in plaats van 15. 15:30 − 15 = 15:15, niet 15:20.",
          "1": "Hier is opgeteld in plaats van afgetrokken. Je moet eerder zijn, dus trek af: 15:30 − 15 = 15:15, niet 15:30 + 15 = 15:45.",
          "2": "Hier is een heel uur afgetrokken in plaats van 15 minuten. 15:30 − 15 min = 15:15, niet 14:15.",
          "3": "Correct! 15:30 − 15 minuten = 15:15."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-subtraction-error", "label": "Te weinig minuten afgetrokken", "optionIndex": 0 },
          { "id": "tijd.add-instead-of-subtract", "label": "Optellen i.p.v. aftrekken", "optionIndex": 1 },
          { "id": "tijd.full-hour-instead-of-minutes", "label": "Heel uur i.p.v. minuten afgetrokken", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-007",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "ordering",
      "question": "Zet de stappen in de juiste volgorde om de eindtijd van een film te berekenen die om 19:30 begint en 1 uur en 45 minuten duurt.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Uurgrens overschreden: 20:30 + 1 uur en 15 min = 21:15",
          "Begintijd noteren: 19:30",
          "Eindtijd: 21:15",
          "Daarna de minuten erbij: 30 min + 45 min = 75 min = 1 uur en 15 min",
          "Eerst het hele uur erbij: 19:30 + 1 uur = 20:30"
        ],
        "correctOrder": [1, 4, 3, 0, 2]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vaste stappenvolgorde",
            "content": "1. Begintijd. 2. Eerst uren optellen. 3. Daarna minuten optellen. 4. Let op uurgrens als minuten > 60. 5. Eindtijd lezen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schedule_end_time_ordering",
      "variantIndex": 7,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Voor eindtijd-berekeningen werk je in vaste volgorde: eerst de hele uren optellen, dan de minuten. Als de minuten boven de 60 komen, splits je in een extra uur plus de rest. Deze volgorde voorkomt fouten.",
        "solutionSteps": [
          "1) Begintijd: 19:30",
          "2) Uur erbij: 19:30 + 1 uur = 20:30",
          "3) Minuten optellen: 30 + 45 = 75 min",
          "4) 75 min = 1 uur 15 min → 20:30 + 1:15 = 21:15",
          "5) Eindtijd: 21:15"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.cross-hour-only-first-part", "label": "Volgorde van uren/minuten optellen door elkaar" }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-008",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Je komt aan om 11:40. De volgende trein vertrekt om 12:05. Hoe lang moet je wachten?",
      "options": ["15 minuten", "25 minuten", "35 minuten", "1 uur en 25 minuten"],
      "correctAnswer": 1,
      "conceptId": "schedule_waiting_cross_hour",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "stimulusAids": [
        {
          "type": "timeline",
          "data": {
            "label": "Wachten op de trein (over uurgrens)",
            "events": [
              { "position": 11.667, "label": "11:40", "description": "Aankomst", "isHighlighted": true },
              { "position": 12.0, "label": "12:00", "description": "Uurgrens", "isHighlighted": false },
              { "position": 12.083, "label": "12:05", "description": "Trein vertrekt", "isHighlighted": true }
            ],
            "start": 11.5,
            "end": 12.5
          },
          "a11y": { "alt": "Tijdlijn van 11:30 tot 12:30 met aankomst 11:40, uurgrens 12:00, treinvertrek 12:05" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wachttijd over uurgrens",
            "content": "Stap voor stap: 11:40 → 12:00 = 20 minuten. 12:00 → 12:05 = 5 minuten. Totaal: 20 + 5 = 25 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Splits de berekening bij de uurgrens. Van 11:40 naar 12:00 is 20 minuten (60 − 40 = 20). Van 12:00 naar 12:05 is 5 minuten. Totaal: 20 + 5 = 25 minuten.",
        "solutionSteps": [
          "Aankomsttijd: 11:40, treintijd: 12:05",
          "Over uurgrens (11 → 12): splitsen",
          "11:40 → 12:00 = 20 min, 12:00 → 12:05 = 5 min",
          "Totaal: 20 + 5 = 25 minuten"
        ],
        "distractorExplanations": {
          "0": "Hier is alleen het tweede deel of de helft geteld. Eerste deel 11:40 → 12:00 = 20 min, tweede deel 12:00 → 12:05 = 5 min. Totaal 25 min.",
          "1": "Correct! 20 + 5 = 25 minuten.",
          "2": "De minuten zijn verkeerd opgeteld. 20 + 5 = 25 minuten, niet 35. Controleer: 11:40 + 35 = 12:15 ≠ 12:05.",
          "3": "Hier is een extra uur meegeteld. De wachttijd gaat over de uurgrens, maar duurt minder dan 1 uur: 25 minuten."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.cross-hour-only-first-part", "label": "Alleen één deel geteld bij uurgrens", "optionIndex": 0 },
          { "id": "tijd.minutes-addition-error", "label": "Minuten verkeerd opgeteld", "optionIndex": 2 },
          { "id": "tijd.extra-hour-added", "label": "Extra uur ten onrechte meegeteld", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-009",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "categorize",
      "question": "Sorteer elke tijdberekening op het soort: binnen één uur, over de uurgrens, of langer dan één uur.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": [
          "Binnen één uur",
          "Net over een heel uur (korter dan 1 uur)",
          "Langer dan 1 uur"
        ],
        "items": [
          { "text": "10:00 → 10:50", "correctCategory": 0 },
          { "text": "14:20 → 14:55", "correctCategory": 0 },
          { "text": "16:30 → 16:50", "correctCategory": 0 },
          { "text": "13:45 → 14:10", "correctCategory": 1 },
          { "text": "11:40 → 12:05", "correctCategory": 1 },
          { "text": "17:35 → 18:10", "correctCategory": 1 },
          { "text": "14:00 → 15:45", "correctCategory": 2 },
          { "text": "19:30 → 21:15", "correctCategory": 2 },
          { "text": "20:00 → 22:15", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welk soort tijdberekening?",
            "content": "Zelfde uur: begin- en eindtijd hebben hetzelfde uurnummer (14:xx → 14:xx). Uurgrens: andere uurnummers, maar minder dan 60 minuten verschil. Langer dan 1 uur: minstens 60 minuten verschil.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schedule_categorize_types",
      "variantIndex": 9,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Door berekeningen vooraf te categoriseren weet je welke methode je nodig hebt. Zelfde uur: direct minuten aftrekken. Uurgrens: splitsen bij het hele uur. Langer dan 1 uur: eerst hele uren tellen, dan minuten.",
        "solutionSteps": [
          "Vergelijk de uurnummers van begin- en eindtijd",
          "Zelfde uurnummer → 'zelfde uur'",
          "Verschillend uurnummer + < 60 min verschil → 'uurgrens'",
          "≥ 60 min verschil → 'langer dan 1 uur'"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.cross-hour-only-first-part", "label": "Soort tijdberekening verkeerd herkend" }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-010",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "fill_in",
      "question": "De bus vertrekt om 08:50. Je moet 20 minuten voor vertrek op de bushalte zijn. Hoe laat moet je er zijn? Typ de tijd als hh:mm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["08:30", "8:30"],
        "caseSensitive": false,
        "placeholder": "hh:mm"
      },
      "conceptId": "schedule_arrive_early_20min",
      "variantIndex": 10,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 8, "minutes": 50, "format": "24h", "label": "Vertrektijd bus" },
          "a11y": { "alt": "Digitale klok toont 08:50, de vertrektijd van de bus" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "20 minuten eerder op de halte",
            "content": "Trek 20 minuten af van de vertrektijd: 08:50 − 20 minuten = 08:30.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Als je eerder moet zijn, trek je de tijd af van de vertrektijd. De vertrektijd is 08:50. Je moet 20 minuten eerder zijn: 08:50 − 20 = 08:30.",
        "solutionSteps": [
          "Vertrektijd: 08:50",
          "Je moet 20 minuten eerder zijn",
          "Trek af: 08:50 − 20 minuten = 08:30",
          "Check: 08:30 + 20 min = 08:50 ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.add-instead-of-subtract", "label": "Optellen i.p.v. aftrekken bij 'eerder'" }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-011",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Een concert begint om 20:00 en duurt 2 uur en 15 minuten. Hoe laat is het concert afgelopen?",
      "options": ["22:15", "21:15", "22:45", "23:15"],
      "correctAnswer": 0,
      "conceptId": "schedule_end_time_evening",
      "variantIndex": 11,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.71,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 20, "minutes": 0, "format": "24h", "label": "Begintijd concert" },
          "a11y": { "alt": "Digitale klok toont 20:00, de begintijd van het concert" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eindtijd concert berekenen",
            "content": "20:00 + 2 uur = 22:00. Dan + 15 minuten = 22:15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Tel de uren en minuten apart op bij de begintijd. 20:00 + 2 uur = 22:00. Dan 22:00 + 15 minuten = 22:15.",
        "solutionSteps": [
          "Begintijd: 20:00, duur: 2 uur en 15 minuten",
          "Eerst de uren: 20:00 + 2 uur = 22:00",
          "Dan de minuten: 22:00 + 15 min = 22:15",
          "Check: 22:15 − 20:00 = 2 uur 15 min ✓"
        ],
        "distractorExplanations": {
          "0": "Correct! 20:00 + 2 uur + 15 min = 22:15.",
          "1": "Hier is maar 1 uur opgeteld in plaats van 2. 20:00 + 1 uur + 15 min = 21:15, maar het concert duurt 2 uur en 15 min: 22:15.",
          "2": "De minuten zijn verkeerd opgeteld. 20:00 + 2 uur = 22:00, dan + 15 min = 22:15, niet 22:45.",
          "3": "Hier is een extra uur opgeteld. 20:00 + 2 uur = 22:00 (niet 23:00). Dan + 15 min = 22:15."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.full-hour-instead-of-minutes", "label": "Te weinig uren opgeteld", "optionIndex": 1 },
          { "id": "tijd.minutes-addition-error", "label": "Minuten verkeerd opgeteld", "optionIndex": 2 },
          { "id": "tijd.extra-hour-added", "label": "Extra uur ten onrechte meegeteld", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TIJD-SCHEMA-012",
      "familyId": "TIJD-SCHEMA",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "comparison_judge",
      "question": "Welke verbinding levert de kortste wachttijd op? Je komt om 14:45 op het station aan.",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "emoji": "🚌", "label": "Bus", "subLabel": "Vertrekt om 15:30" },
            { "emoji": "🚆", "label": "Trein", "subLabel": "Vertrekt om 15:00" },
            { "emoji": "🚇", "label": "Metro", "subLabel": "Vertrekt om 15:10" }
          ],
          "criterion": "de kortste wachttijd",
          "correctIndex": 1
        }
      },
      "options": [],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "digitalClock",
          "data": { "hours": 14, "minutes": 45, "format": "24h", "label": "Aankomst station" },
          "a11y": { "alt": "Digitale klok toont 14:45, je aankomsttijd op het station" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wachttijden vergelijken",
            "content": "Bereken voor elke verbinding hoelang je moet wachten vanaf 14:45. De kleinste wachttijd is je antwoord.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schedule_compare_waiting",
      "variantIndex": 12,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Bereken voor elke verbinding de wachttijd vanaf 14:45. Bus 15:30: 14:45 → 15:00 = 15 min, 15:00 → 15:30 = 30 min, totaal 45 min. Trein 15:00: 14:45 → 15:00 = 15 min. Metro 15:10: 14:45 → 15:00 = 15 min, 15:00 → 15:10 = 10 min, totaal 25 min. De trein heeft de kortste wachttijd: 15 minuten.",
        "solutionSteps": [
          "Bereken wachttijd per verbinding vanaf 14:45",
          "Bus 15:30: 45 minuten wachten",
          "Trein 15:00: 15 minuten wachten",
          "Metro 15:10: 25 minuten wachten",
          "Kortste: trein, 15 minuten"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.cross-hour-only-first-part", "label": "Wachttijd over uurgrens verkeerd berekend" }
        ]
      }
    }
  ]
}
